import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { LiveEventPoliciesLoadAction } from '../../domains/liveEventPoliciesLoad/actions.types';

import type { LiveEventPoliciesLifecycle } from './types';

const initialState: LiveEventPoliciesLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

export type LiveEventPoliciesAction = LiveEventPoliciesLoadAction;

const reducer: Reducer<LiveEventPoliciesLifecycle> = (state = initialState, action: LiveEventPoliciesAction) => {
  switch (action.type) {
    case 'LIVE_EVENT_POLICIES.LOAD_PENDING':
      return setPending();
    case 'LIVE_EVENT_POLICIES.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.liveEventPolicies);
    case 'LIVE_EVENT_POLICIES.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
